<template>
  <div class="page-content">
    <div class="log-container">
        <div class="log-content-one">
            <div class="content-one-container">
                <div class="content-one-wrap">
                    <img class="logo_pic" src="../../assets/images/login/branner_v3.png">
    						<!-- <span class="nav-line">
    						</span>
    						<span class="nav-text-left">
    							需求方平台
    						</span> -->
    						<span class="nav-text-right">
    						</span>
                </div>
                <div class="content-one-left">

                </div>
                <div class="content-one-right">
                    <div class="one-right-container">
                        <div class="one-right-title">
                            平台登录
                        </div>
                        <div class="one-right-input">
                            <el-input id="phone" @keypress.native.enter="login" type="text" v-model="username" placeholder="请输入手机号或邮箱号" name="phone"></el-input>
                        </div>
                        <div class="one-right-input">
                            <el-input id="passWord" @keypress.native.enter="login" type="password" v-model="password" placeholder="请输入用户密码" name="password" maxlength="18"></el-input>
                        </div>
                        <div class="one-right-inputnum" style="display: flex;">
                            <el-input id="code" @keypress.native.enter="login" type="text" placeholder="验证码" name="code" maxlength="4" v-model="code" style="width: 140px;"></el-input>
                            <verify-code :identifyCode="verify_code" @getCode="getCode()" style="margin-left: 10px;"></verify-code>
                            <div class="empty"></div>
                        </div>
                        <div class="errMsg" v-text="emptyText">
                        </div>
                        <div class="test-container">
                            <div class="btn-bg test-btn">
                              <span id="login" @click="login">登录</span>
                            </div>
                        </div>
                        <!-- <div class="one-right-bottom">
                            <div class="register">
                                <a href="http://e.ssp.eastdaymedia.com.cn/register.html?v=2">
                                    免费注册
                                </a>
                            </div>
                            <div class="forget-password">
                                <a href="http://e.ssp.eastdaymedia.com.cn/forgetpwd.html?v=2">
                                    忘记密码
                                </a>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="intro">
              <div class="intro_main">
                  <dl class="">
                      <dt><img src="../../assets/images/login/about.png" style="margin-top:-3px;" alt=""> 关于懂球号</dt>
                      <dd>· 懂球帝开放自媒体平台，自由发布个性化内容</dd>
                      <dd>· 对应懂球帝APP专属主页，获得球迷关注</dd>
                  </dl>
                  <dl class="">
                      <dt><img src="../../assets/images/login/fuli.png" alt=""> 懂球号福利</dt>
                      <dd>· 内容直达懂球帝数千万球迷，数百万日活用户</dd>
                      <dd>· 优质内容获得大流量扶持</dd>
                      <dd>· 优质创作者可申请开通收益补贴</dd>
                  </dl>
                  <dl class="">
                      <dt><img src="../../assets/images/login/ruzhu.png" style="margin-top:-2px;" alt=""> 如何入驻</dt>
                      <dd>· 打开手机侧边栏 点击开通懂球号</dd>
                      <dd>· 获得懂球号账户，开启懂球号之旅</dd>
                  </dl>
              </div>
          </div>

        <div class="footer">
            <a href="http://www.dongqiudi.com/article/1668870" target="_blank">关于懂球号</a> ｜
            <a href="http://www.dongqiudi.com/article/197503" target="_blank">用户协议</a> ｜
            <a href="http://weibo.com/ballpure?is_all=1" target="_blank">官方微博</a> ｜
            <a href="http://www.dongqiudi.com/app" target="_blank">客户端下载</a> ｜
            <a href="mailto:dqh2016@dongqiudi.com" target="_blank">联系邮箱</a>
           <!--   <a href="#" onclick="return false">客服QQ：3303573305</a>  -->
        </div>
    </div>
  </div>
</template>
<script>
export default {
  /* global require */
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
      code: '',
      verify_code: '',
      pics: '',
      emptyText: '',
      trmorrw: ''
    };
  },
  created() {
    if (sessionStorage.getItem('token')) {
      this.$router.push({ path: '/' });
    }
    this.getCode();
    this.setTime();
  },
  beforeCreate() {
    if (this.$route.query.token) {
      this.$http.post('/trader/login/login', {
        token: this.$route.query.token
      }).then(res => {
        if (res.code === 200) {
          window.location.href = this.$Config.apiUrl;
        } else {
          this.$router.push({ path: '/login' });
        }
      });
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
    setTime() {
      const day3 = new Date();
      day3.setTime(day3.getTime() + 24 * 60 * 60 * 1000);
      this.trmorrw = day3.getFullYear() + '/' + (day3.getMonth() + 1) + '/' + day3.getDate() + ' 00:00:00';
      this.resetTime();
    },
    resetTime() {
      const end_time = new Date(this.trmorrw).getTime();
      const now_time = new Date().getTime();
      this.pics = (((86400 - parseInt((end_time - now_time) / 1000))) * 6425) + '';
      setTimeout(this.resetTime, 1000);
    },
    getCode() {
      const str = '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKMNOPQRSTUVWXYZ';
      const codes = str.split('');
      const arr = [];
      for (let i = 0; i < 4; i++) { // 从0-61之间取随机数
        const index = Math.floor(Math.random() * (58 - 0 + 1) + 0);
        const char = codes[index];
        arr.push(char);
      }
      this.verify_code = arr.join('');
    },
    getBg(index) {
      return this.$Config.apiUrl + '/static/images/' + index + '.png';
    },
    login() {
      if (this.username === '') {
        this.emptyText = '用户名不能为空';
        return false;
      }
      if (this.password === '') {
        this.emptyText = '密码不能为空';
        return false;
      }
      if (this.code === '') {
        this.emptyText = '验证码不能为空';
        return false;
      }
      if (this.code.toLowerCase() !== this.verify_code.toLowerCase()) {
        this.emptyText = '验证码有误';
        this.getCode();
        return false;
      }
      this.$http.post('/trader/login/doLogin', {
        username: this.username,
        password: this.password
      })
        .then(res => {
          if (res.code === 200) {
            this.$router.push({ path: '/' });
          } else {
            this.$message.error(res.msg);
          }
        });
    }
  },
  components: { VerifyCode: resolve => require(['./Components/VerifyCode.vue'], resolve) },
  watch: {
    username() {
      this.emptyText = '';
    },
    password() {
      this.emptyText = '';
    },
    codeA() {
      this.emptyText = '';
    }
  }
};
</script>
<style>
  @import '../../assets/css/login.css';

</style>
